import React from "react";
import { Stack } from "@mui/material";

import { HubFilterMenu, HubHookFormWrapper } from "../../components";
import { BOX_STATUS, BOX_STATUS_OPTIONS } from "../../constants/boxing";
import ContactsLocationFilter from "../../pages/Companies/ContactsLocationFilter";
import ShipmentOrdersCustomerFilter from "./ShipmentOrdersCustomerFilter";

const buttonProps = {
  variant: "tinyButton",
  color: "neutral",
  sx: { backgroundColor: "hubColors.white" },
  iconProps: { size: 10 },
};
const ShipmentOrdersFilter = () => {
  return (
    <HubHookFormWrapper sx={{ width: "fit-content" }}>
      <Stack direction="row" gap="5px">
        <HubFilterMenu
          id="status"
          buttonProps={buttonProps}
          options={BOX_STATUS_OPTIONS?.filter(({ id }) => ![2, 4].includes(id))}
          defaultValue={[BOX_STATUS.READY, BOX_STATUS.SHIPPED]}
          menuLabel="Filter Shipments by Status"
          label="Status"
          icon="Disc"
        />
        <ContactsLocationFilter icon="MapPin" buttonProps={buttonProps} />
        <ShipmentOrdersCustomerFilter buttonProps={buttonProps} />
      </Stack>
    </HubHookFormWrapper>
  );
};
export default ShipmentOrdersFilter;
